import { render, staticRenderFns } from "./outsource-lawsuit-back-manage.vue?vue&type=template&id=30e9fd5d"
import script from "./outsource-lawsuit-back-manage.vue?vue&type=script&lang=ts"
export * from "./outsource-lawsuit-back-manage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports